import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { orderBy } from 'lodash-es';
import { uniqBy } from 'lodash-es';
import { without } from 'lodash-es';
import { debounce } from 'lodash-es';
import CapacityTypeSelectorOverlay from './CapacityTypeSelectorOverlay.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { DOT_SYMBOL } from '~/constants';
import ColorSelectorOverlay from '~/components/Layout/Cart/AddToCart/ColorSelectorOverlay.vue';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import { ProductAttributes, ProductKeys } from '~/types/ProductEnums';
import { convertCapacityUnit, getCapacityString } from '~/helpers/convertCapacityUnit';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  components: {
    PriceDisplay: PriceDisplay,
    AzIcon: AzIcon,
    ColorSelectorOverlay: ColorSelectorOverlay,
    CapacityTypeSelectorOverlay: CapacityTypeSelectorOverlay,
    PriceDiscountLabel: PriceDiscountLabel,
    AzImg: AzImg
  },
  props: {
    onPlp: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object
    },
    configuration: {
      type: Object
    },
    product: {
      type: Object
    },
    firstSelectedIsColor: {
      type: Boolean,
      default: null
    },
    defaultImage: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, _ref) {
    var _currentlySelectedVar, _currentlySelectedVar2, _currentlySelectedVar3;
    var emit = _ref.emit;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var isColorOverlayToggled = ref(false);
    var isCapacityTypeOverlayToggled = ref(false);
    var currentlySelectedColor = ref();
    var colorsImages = ref();
    var variantsCombinations = ref();
    var currentlySelectedVariant = ref();
    var sellable = props.onPlp ? inject('sellable') : ref(true);
    var currentVariantHasColor = ref(false);
    var variantsSellableState = ref({});
    var config = toRefs(props).configuration;
    var toggleColorOverlay = function toggleColorOverlay() {
      if (!isMobile.value) return;
      isColorOverlayToggled.value = !isColorOverlayToggled.value;
    };
    var toggleCapacityTypeOverlay = debounce(function () {
      if (!isMobile.value) return;
      isCapacityTypeOverlayToggled.value = !isCapacityTypeOverlayToggled.value;
    }, 50);
    var sortAlphabetically = function sortAlphabetically(a, b) {
      var _a$color, _b$color;
      var aColor = (_a$color = a.color) === null || _a$color === void 0 ? void 0 : _a$color.label;
      var bColor = (_b$color = b.color) === null || _b$color === void 0 ? void 0 : _b$color.label;
      if (aColor > bColor) return 1;
      if (aColor < bColor) return -1;
      return 0;
    };
    var getPriceForDiscount = function getPriceForDiscount(item) {
      var _item$value, _item$discounted, _item$discounted$valu;
      return {
        regular: item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.centAmount,
        special: item === null || item === void 0 ? void 0 : (_item$discounted = item.discounted) === null || _item$discounted === void 0 ? void 0 : (_item$discounted$valu = _item$discounted.value) === null || _item$discounted$valu === void 0 ? void 0 : _item$discounted$valu.centAmount
      };
    };
    var parseImage = function parseImage(option) {
      var color = colorsImages.value.find(function (variant) {
        return variant.color === ((option === null || option === void 0 ? void 0 : option.value) || option);
      });
      return color.image ? color === null || color === void 0 ? void 0 : color.image : props.defaultImage;
    };
    var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
    };
    var findRawAttribute = function findRawAttribute(variant, attributeName) {
      var _variant$attributesRa;
      return (_variant$attributesRa = variant.attributesRaw.find(function (attribute) {
        return attribute.name == attributeName;
      })) === null || _variant$attributesRa === void 0 ? void 0 : _variant$attributesRa.value;
    };
    var getVariantAttribute = function getVariantAttribute(attributes, variant, attribute) {
      var _variant$value, _variant$value$attrib, _variant$value2;
      var isLocalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var skipCurrent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      if (isLocalized) return (attributes === null || attributes === void 0 ? void 0 : attributes.value) || ((_variant$value = variant.value) === null || _variant$value === void 0 ? void 0 : (_variant$value$attrib = _variant$value[attribute]) === null || _variant$value$attrib === void 0 ? void 0 : _variant$value$attrib.value) || undefined;
      return (attributes === null || attributes === void 0 ? void 0 : attributes[attribute]) || (skipCurrent ? undefined : (_variant$value2 = variant.value) === null || _variant$value2 === void 0 ? void 0 : _variant$value2[attribute]) || undefined;
    };
    var checkAttribute = function checkAttribute(existingOptions, currentOption, attribute) {
      var _existingOptions$attr;
      var isLocalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (isLocalized) return (existingOptions === null || existingOptions === void 0 ? void 0 : (_existingOptions$attr = existingOptions[attribute]) === null || _existingOptions$attr === void 0 ? void 0 : _existingOptions$attr.value) === (currentOption === null || currentOption === void 0 ? void 0 : currentOption[attribute]);
      return (existingOptions === null || existingOptions === void 0 ? void 0 : existingOptions[attribute]) === (currentOption === null || currentOption === void 0 ? void 0 : currentOption[attribute]);
    };
    var onSelectColor = function onSelectColor(variantAttributes) {
      emit('on-selected-changed', true);
      var selectedVariant = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ProductKeys.capacity, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacity)), ProductKeys.capacityUnit, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacityUnit)), ProductKeys.capacityType, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacityType)), ProductKeys.color, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.color, true));
      var isVariantExisting = !!variantsCombinations.value.find(function (existingVariant) {
        return checkAttribute(existingVariant, selectedVariant, ProductKeys.capacity) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityUnit) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityType) && checkAttribute(existingVariant, selectedVariant, ProductKeys.color, true);
      });
      if (!isVariantExisting) {
        // if selected variant doesnt exist, find selectable variant with different capacity
        var substitute = variantsCombinations.value.find(function (existingVariant) {
          return checkAttribute(existingVariant, selectedVariant, ProductKeys.color, true) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityUnit);
        });
        if (substitute) {
          delete substitute.label;
          delete substitute.price;
          delete substitute.isSellable;
          substitute.color = substitute.color.value;
          emit('onSelect', substitute);
          return;
        }
      }
      if (isVariantExisting) {
        emit('onSelect', selectedVariant);
      }
    };
    var onSelectCapacity = function onSelectCapacity(variantAttributes) {
      emit('on-selected-changed', true);
      var selectedVariant = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ProductKeys.capacity, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacity, false, true)), ProductKeys.capacityUnit, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacityUnit, false, true)), ProductKeys.capacityType, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.capacityType, false, true)), ProductKeys.color, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.color, true, true)), ProductKeys.color, getVariantAttribute(variantAttributes, currentlySelectedVariant, ProductKeys.color, true));
      var isVariantExisting = !!variantsCombinations.value.find(function (existingVariant) {
        return checkAttribute(existingVariant, selectedVariant, ProductKeys.capacity) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityUnit) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityType) && checkAttribute(existingVariant, selectedVariant, ProductKeys.color, true);
      });
      if (!isVariantExisting) {
        // if selected variant doesn't exist, find selectable variant with different color
        var substitute = variantsCombinations.value.find(function (existingVariant) {
          return checkAttribute(existingVariant, selectedVariant, ProductKeys.capacity) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityUnit) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityType);
        });
        if (substitute) {
          delete substitute.label;
          delete substitute.price;
          delete substitute.isSellable;
          substitute.color = substitute.color.value;
          emit('onSelect', substitute);
          return;
        }
      }
      if (isVariantExisting) {
        emit('onSelect', selectedVariant);
      }
    };
    var newVariantsList = computed(function () {
      var _props$product$_origi;
      var list = (_props$product$_origi = props.product._original) === null || _props$product$_origi === void 0 ? void 0 : _props$product$_origi.masterData.current.allVariants.map(function (variant) {
        var _variant$price, _variant$price$value, _capacityUnit$label, _capacityType$label, _variant$images, _variant$images$;
        var isComplimentary = findRawAttribute(variant, ProductKeys.isComplimentary);
        if (!(variant !== null && variant !== void 0 && variant.sku) || !(variant !== null && variant !== void 0 && (_variant$price = variant.price) !== null && _variant$price !== void 0 && (_variant$price$value = _variant$price.value) !== null && _variant$price$value !== void 0 && _variant$price$value.centAmount) || isComplimentary) return;
        var capacity = findRawAttribute(variant, ProductKeys.capacity);
        var capacityUnit = findRawAttribute(variant, ProductKeys.capacityUnit);
        var capacityType = findRawAttribute(variant, ProductKeys.capacityType);
        var color = findRawAttribute(variant, ProductKeys.color);
        var capacityAndUnitLabel = getCapacityString(capacity, capacityUnit === null || capacityUnit === void 0 ? void 0 : (_capacityUnit$label = capacityUnit.label) === null || _capacityUnit$label === void 0 ? void 0 : _capacityUnit$label[locale]);
        var capacityTypeLabel = (capacityType === null || capacityType === void 0 ? void 0 : (_capacityType$label = capacityType.label) === null || _capacityType$label === void 0 ? void 0 : _capacityType$label[locale]) || '';
        var separator = capacityTypeLabel ? " ".concat(DOT_SYMBOL, " ") : '';
        var isSellable = findRawAttribute(variant, ProductKeys.isSellable);
        return {
          sku: variant === null || variant === void 0 ? void 0 : variant.sku,
          price: variant === null || variant === void 0 ? void 0 : variant.price,
          isSellable: (isSellable === null || isSellable === void 0 ? void 0 : isSellable.key) == ProductKeys.inStock,
          isDiscontinued: isSellable.key == ProductKeys.discontinued,
          mainImage: variant === null || variant === void 0 ? void 0 : (_variant$images = variant.images) === null || _variant$images === void 0 ? void 0 : (_variant$images$ = _variant$images[0]) === null || _variant$images$ === void 0 ? void 0 : _variant$images$.url,
          attributes: {
            capacity: _defineProperty(_defineProperty(_defineProperty({
              capacity: capacity
            }, ProductKeys.capacityType, capacityType === null || capacityType === void 0 ? void 0 : capacityType.key), ProductKeys.capacityUnit, capacityUnit === null || capacityUnit === void 0 ? void 0 : capacityUnit.key), "label", capacityAndUnitLabel + separator + capitalizeFirstLetter(capacityTypeLabel)),
            color: {
              label: color === null || color === void 0 ? void 0 : color.label[locale],
              value: color === null || color === void 0 ? void 0 : color.key
            }
          }
        };
      });
      return without(list, undefined);
    });
    if (props.options.capacity || props.options.color) {
      variantsCombinations.value = newVariantsList.value.map(function (variant) {
        return _objectSpread(_objectSpread({}, variant.attributes.capacity), {}, {
          color: variant.attributes.color,
          price: variant.price,
          isSellable: variant.isSellable,
          isDiscontinued: variant.isDiscontinued
        });
      });
    }
    watch(config, function (newConfig) {
      if (props.options.capacity || props.options.color) {
        currentlySelectedVariant.value = variantsCombinations.value.find(function (option) {
          return checkAttribute(option, newConfig, ProductKeys.capacity) && checkAttribute(option, newConfig, ProductKeys.capacityUnit) && checkAttribute(option, newConfig, ProductKeys.capacityType) && checkAttribute(option, newConfig, ProductKeys.color, true);
        });
      }
    }, {
      immediate: true
    });
    currentVariantHasColor.value = (_currentlySelectedVar = currentlySelectedVariant.value) === null || _currentlySelectedVar === void 0 ? void 0 : (_currentlySelectedVar2 = _currentlySelectedVar.color) === null || _currentlySelectedVar2 === void 0 ? void 0 : _currentlySelectedVar2.value;
    sellable.value = (_currentlySelectedVar3 = currentlySelectedVariant.value) === null || _currentlySelectedVar3 === void 0 ? void 0 : _currentlySelectedVar3.isSellable;
    if (props.options.color) {
      currentlySelectedColor.value = props.options.color.find(function (option) {
        return option.value === props.configuration.color;
      });
      colorsImages.value = newVariantsList.value.map(function (variant) {
        return {
          color: variant.attributes.color.value,
          image: variant.mainImage,
          isSellable: variant.isSellable,
          isDiscontinued: variant.isDiscontinued
        };
      });
    }
    var filteredColors = computed(function () {
      return orderBy(variantsCombinations.value.filter(function (variant) {
        return checkAttribute(currentlySelectedVariant.value, variant, ProductKeys.capacity) && checkAttribute(currentlySelectedVariant.value, variant, ProductKeys.capacityUnit) && checkAttribute(currentlySelectedVariant.value, variant, ProductKeys.capacityType);
      }).map(function (variant) {
        if (variant.color) {
          return _objectSpread(_objectSpread({}, variant.color), {}, {
            price: variant.price,
            isSellable: variant.isSellable,
            isDiscontinued: variant.isDiscontinued
          });
        }
      }).filter(function (variant) {
        return !variant.isDiscontinued;
      }), [ProductAttributes.isSellable, 'label'], ['desc', 'asc']);
    });
    var mapCapacityWithProperSellable = function mapCapacityWithProperSellable(arr) {
      return arr.map(function (item) {
        var _variantsSellableStat;
        return _objectSpread(_objectSpread({}, item), {}, {
          isSellable: (_variantsSellableStat = variantsSellableState.value[item.label]) !== null && _variantsSellableStat !== void 0 ? _variantsSellableStat : item.isSellable
        });
      });
    };
    var checkIsSellableBasedOnEveryVariant = function checkIsSellableBasedOnEveryVariant(variants) {
      var checkedObj = {};
      Object.keys(variants).forEach(function (key) {
        var variantsLabel = variants[key].label;
        var isVariantSellable = variants[key].isSellable;
        if (!checkedObj.hasOwnProperty(variantsLabel)) {
          checkedObj[variantsLabel] = isVariantSellable !== null && isVariantSellable !== void 0 ? isVariantSellable : false;
        } else if (!checkedObj[variantsLabel] && isVariantSellable) {
          checkedObj[variantsLabel] = true;
        }
      });
      return checkedObj;
    };
    var filteredCapacityAndType = computed(function () {
      variantsSellableState.value = checkIsSellableBasedOnEveryVariant(variantsCombinations.value);
      var filterAndSorted = orderBy(uniqBy(variantsCombinations.value, function (attribute) {
        var _attribute$price;
        return ((_attribute$price = attribute.price) === null || _attribute$price === void 0 ? void 0 : _attribute$price.discounted) || attribute.label;
      }), [function (attribute) {
        return attribute.isSellable;
      }], ['desc']);
      var mappedFilterAndSorted = mapCapacityWithProperSellable(filterAndSorted).sort(function (a, b) {
        if (a.isSellable !== b.isSellable) {
          return a.isSellable === b.isSellable ? 0 : a.isSellable ? -1 : 1;
        } else {
          return convertCapacityUnit(a) > convertCapacityUnit(b) ? 1 : -1;
        }
      });
      return uniqBy(mappedFilterAndSorted, function (attribute) {
        return attribute.label;
      });
    });
    /**
     * Verifies if the provided data matches the color label of the currently selected variant and checks if the item is not discontinued.
     * @param {object} data - The object containing the color label to verify and its discontinued status.
     * @returns {boolean} - Returns true if the data's color label matches the currently selected variant's color label and the item is not discontinued, otherwise false.
     */
    function verifyColorLabel(data) {
      var _currentlySelectedVar4;
      return (data === null || data === void 0 ? void 0 : data.label) === ((_currentlySelectedVar4 = currentlySelectedVariant.value) === null || _currentlySelectedVar4 === void 0 ? void 0 : _currentlySelectedVar4.color.label) && !data.isDiscontinued;
    }

    /**
     * Verifies if the label of the provided data matches the label of the currently selected variant and checks if the item is not discontinued.
     * @param {object} data - The object containing the label to verify and its discontinued status.
     * @returns {boolean} - Returns true if the data's label matches the currently selected variant's label and the item is not discontinued, otherwise false.
     */
    function verifyLabel(data) {
      var _currentlySelectedVar5;
      return data.label === ((_currentlySelectedVar5 = currentlySelectedVariant.value) === null || _currentlySelectedVar5 === void 0 ? void 0 : _currentlySelectedVar5.label) && !data.isDiscontinued;
    }
    (function (_currentlySelectedVar6, _currentlySelectedVar7, _currentlySelectedVar8, _currentlySelectedVar9, _currentlySelectedVar0, _variantsCombinations) {
      var selectedVariant = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ProductKeys.capacity, (_currentlySelectedVar6 = currentlySelectedVariant.value) === null || _currentlySelectedVar6 === void 0 ? void 0 : _currentlySelectedVar6[ProductKeys.capacity]), ProductKeys.capacityUnit, (_currentlySelectedVar7 = currentlySelectedVariant.value) === null || _currentlySelectedVar7 === void 0 ? void 0 : _currentlySelectedVar7[ProductKeys.capacityUnit]), ProductKeys.capacityType, (_currentlySelectedVar8 = currentlySelectedVariant.value) === null || _currentlySelectedVar8 === void 0 ? void 0 : _currentlySelectedVar8[ProductKeys.capacityType]), ProductKeys.color, (_currentlySelectedVar9 = currentlySelectedVariant.value) === null || _currentlySelectedVar9 === void 0 ? void 0 : _currentlySelectedVar9[ProductKeys.color].value), ProductKeys.isDiscontinued, (_currentlySelectedVar0 = currentlySelectedVariant.value) === null || _currentlySelectedVar0 === void 0 ? void 0 : _currentlySelectedVar0[ProductKeys.isDiscontinued]);
      var isVariantExisting = !!((_variantsCombinations = variantsCombinations.value) !== null && _variantsCombinations !== void 0 && _variantsCombinations.find(function (existingVariant) {
        return checkAttribute(existingVariant, selectedVariant, ProductKeys.capacity) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityUnit) && checkAttribute(existingVariant, selectedVariant, ProductKeys.capacityType) && checkAttribute(existingVariant, selectedVariant, ProductKeys.color, true);
      }));
      if (props.product._master && (!isVariantExisting || currentlySelectedVariant.value.isDiscontinued)) {
        var _variantsCombinations2;
        var activeVariants = (_variantsCombinations2 = variantsCombinations.value) === null || _variantsCombinations2 === void 0 ? void 0 : _variantsCombinations2.filter(function (variant) {
          return !variant.isDiscontinued;
        });
        var minimumCapacity = activeVariants ? Math.min.apply(Math, _toConsumableArray(activeVariants.map(function (item) {
          return convertCapacityUnit(item);
        }))) : null;
        var lowestCapacitySubstitutes = activeVariants ? activeVariants.filter(function (variant) {
          return convertCapacityUnit(variant) === minimumCapacity;
        }).sort(sortAlphabetically) : [];
        if (lowestCapacitySubstitutes.length) {
          var _lowestCapacitySubsti;
          emit('onSelect', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ProductKeys.capacity, lowestCapacitySubstitutes[0][ProductKeys.capacity]), ProductKeys.capacityUnit, lowestCapacitySubstitutes[0][ProductKeys.capacityUnit]), ProductKeys.color, (_lowestCapacitySubsti = lowestCapacitySubstitutes[0][ProductKeys.color]) === null || _lowestCapacitySubsti === void 0 ? void 0 : _lowestCapacitySubsti.value), ProductKeys.capacityType, lowestCapacitySubstitutes[0][ProductKeys.capacityType]), {
            noHistory: true
          });
        }
      }
    })();
    var shouldDisableDropdown = function shouldDisableDropdown(options) {
      return options.length < 1;
    };
    return {
      verifyColorLabel: verifyColorLabel,
      verifyLabel: verifyLabel,
      currentlySelectedColor: currentlySelectedColor,
      currentlySelectedVariant: currentlySelectedVariant,
      colorsImages: colorsImages,
      capitalizeFirstLetter: capitalizeFirstLetter,
      isMobile: isMobile,
      isColorOverlayToggled: isColorOverlayToggled,
      isCapacityTypeOverlayToggled: isCapacityTypeOverlayToggled,
      toggleColorOverlay: toggleColorOverlay,
      toggleCapacityTypeOverlay: toggleCapacityTypeOverlay,
      translate: translate,
      parseImage: parseImage,
      filteredColors: filteredColors,
      filteredCapacityAndType: filteredCapacityAndType,
      variantsCombinations: variantsCombinations,
      getPriceForDiscount: getPriceForDiscount,
      currentVariantHasColor: currentVariantHasColor,
      shouldDisableDropdown: shouldDisableDropdown,
      onSelectCapacity: onSelectCapacity,
      onSelectColor: onSelectColor
    };
  }
});